
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lab",
      function () {
        return require("private-next-pages/lab/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lab"])
      });
    }
  